module.exports = __webpack_public_path__ + "media/images/menu/hercules-712c7956fa20dcc4f1345d7924e3f7bd.jpg";